// extracted by mini-css-extract-plugin
module.exports = {"Container":"SmallBundleListItem_Container__3MJ_m","Img":"SmallBundleListItem_Img__bE4bC","PageTitle":"SmallBundleListItem_PageTitle__ntCAb"};